const apiConfig = {
  "search-edge":
    process.env.NODE_ENV !== "production"
      ? "https://www.dmx.eis-deliverydevqa.cloud"
      : "",
};

export default apiConfig;
